import src from "IMAGE";
export default { src, width: 652, height: 929, blurWidth: 0, blurHeight: 0};
